@let booking = booking$ | async; @let bookingHotel = booking?.bookingHotel;
@if (isLoading) {
  <booking-loading-page />
} @else {
  <header></header>

  <div class="booking-page-body">
    @if (bookingHotel) {
      <booking-hotel [data]="booking" />
    } @else {
      <booking-trip [data]="booking" />
    }
  </div>
}

<footer></footer>
